import React, { useEffect, useState } from 'react';
import { Sec2Str, Str2Sec } from '../../helpers/timeHelper';
import { format } from "date-fns";
import BiHelp from './BiHelp';

const BiTimePicker = ({
    name,
    value,
    onChange,
    disabled,
    width,
    format: timeFormat,
    flex,
    help,
    helpKey,
    helpMainKey

}) => {
    let dod = {
        width: width == null ? "135px" : ((width) + "px"),
        display: "inline-flex",
        flex:flex==null?null:flex,
        alignItems: "center",
        position: "relative"
    }

    
    const [time, setTime] = useState("");

    useEffect(() => {
        if (value != null) {
            setTime(Sec2Str(value,timeFormat));
        } else {
            setTime("");
        }
    }, [value]);

    const onChanged = (e) => {
        let sec = null;
        if (e.target.value != "" && e.target.value != null) {
            sec = Str2Sec(e.target.value, timeFormat);
            setTime(Sec2Str(sec, timeFormat))
        }
        else {
            setTime("")
        }

        if (onChange != null) {
            onChange({ target: { name: e.target.name, value: sec } });
        }
    }
    return (

        
          <div  style={dod}>

             <input

                type="text"
                className="form-control form-control-sm"
                name={name}
                disabled={disabled ? "disabled" : ""}
                onBlur={(e) => onChanged(e)}
                onChange={(e) => setTime(e.target.value)}
                value={time} />
            <i className="fas fa-clock"
                style={{
                    position: "absolute",
                    right: ((help == true) ? "23px" : "10px"),
                    color: "#626262"
                }}
            ></i>


            {(help == true) &&
                <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
            }
        </div>


    );
}

export default BiTimePicker;

